import React from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';

const SummaryProductRow = ({ product, qty, multiple, type }) => {
  const priceActual =
    multiple !== undefined && multiple ? qty * product.price.actual : product.price.actual;
  const priceRegular =
    multiple !== undefined && multiple ? qty * product.price.regular : product.price.regular;

  let typeText = '';
  if (type === 'fronts') {
    typeText = 'Kolor frontu';
  }
  if (type === 'handles') {
    typeText = 'Uchwyt';
  }
  if (type === 'track') {
    typeText = product.name.split(' ');
    typeText = typeText[0] + ' ' + typeText[1];
  }
  return (
    <div className="text-summary__row">
      {type !== 'addons' && (
        <p className="text-summary__paragraph text-summary--capitalize-first-letter">{typeText}</p>
      )}
      <p className="text-summary__paragraph text-summary__paragraph--width" title={product.safo}>
        {type === 'track' ? product.name.split(' ').slice(2).join(' ') : product.name}{' '}
        {qty !== undefined && qty > 1 ? ` x\u00A0` + qty : ''}
      </p>
      {type === 'addons' && <p></p>}
      {priceActual < priceRegular && (
        <p className="text-summary__price text-summary__price--decoration">
          <Currency quantity={priceRegular} currency="PLN" />
        </p>
      )}
      <p className="text-summary__price">
        <Currency quantity={priceActual} currency="PLN" />
      </p>
    </div>
  );
};

SummaryProductRow.propTypes = {
  product: PropTypes.object.isRequired,
  qty: PropTypes.number,
  multiple: PropTypes.bool,
};

export default SummaryProductRow;
